//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone' 
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const conditionEnum = [
  {value:'CONTAMINATION', label:'Contamination'}, 
  {value:'FAILING_SITE_IMPROVEMENT', label:'Failing Site Improvement'}, 
  {value:'ENCROACHMENTS', label:'Encroachments'}, 
  {value:'SIGNIFICANT_JUNK_TRASH', label:'Significant Junk Trash'}, 
  {value:'SINKHOLE', label:'Sinkhole'}, 
  {value:'WETLANDS', label:'Wetlands'}, 
  {value:'EXTREME_SLOPE', label:'Extreme Slope'}, 
  {value:'OTHER', label:'Other'}, 
  {value:'NONE_OBSERVED', label:'None Observed'}, 
];

const nonResidentialUseEnum = [
  {value:'CHILDCARE', label:'Childcare'}, 
  {value:'ELDERCARE', label:'Eldercare'}, 
  {value:'BOARDING_HOUSE', label:'Boarding House'}, 
  {value:'AUTO_SHOP', label:'Auto Shop'}, 
  {value:'MEDICAL', label:'Medical'}, 
  {value:'SALON', label:'Salon'}, 
  {value:'OFFICE', label:'Office'}, 
  {value:'RETAIL', label:'Retail'}, 
  {value:'HOTEL_BED_BREAKFAST', label:'Hotel Bed Breakfast'}, 
  {value:'FOOD_SERVICE', label:'Food Service'}, 
  {value:'AGRICULTURE', label:'Agriculture'}, 
  {value:'GROW_ROOM', label:'Grow Room'}, 
  {value:'OTHER', label:'Other'}, 
  {value:'NONE_OBSERVED', label:'None Observed'}, 
];

const improvementEnum = [
  {value:'ORNATE_LANDSCAPING', label:'Ornate Landscaping'}, 
  {value:'IRRIGATION_SYSTEM', label:'Irrigation System'}, 
  {value:'GRAYWATER_SYSTEM', label:'Graywater System'}, 
  {value:'WATER_COLLECTION_SYSTEM', label:'Water Collection System'}, 
  {value:'OUTDOOR_KITCHEN', label:'Outdoor Kitchen'}, 
  {value:'INGROUND_POOL', label:'Inground Pool'}, 
  {value:'INGROUND_HOTTUB', label:'Inground Hottub'}, 
  {value:'SPORTS_COURT', label:'Sports Court'}, 
  {value:'SAUNA', label:'Sauna'}, 
  {value:'ORCHARD_HOBBY', label:'Orchard Hobby'}, 
  {value:'VINEYARD_HOBBY', label:'Vineyard Hobby'}, 
  {value:'FENCE', label:'Fence'}, 
  {value:'GAZEBO', label:'Gazebo'}, 
  {value:'GREENHOUSE', label:'Greenhouse'}, 
  {value:'TOOL_SHED', label:'Tool Shed'}, 
  {value:'PATIO', label:'Patio'}, 
  {value:'DECK', label:'Deck'}, 
  {value:'BALCONY', label:'Balcony'}, 
  {value:'UNCOVERED_PORCH', label:'Uncovered Porch'}, 
  {value:'COVERED_PORCH', label:'Covered Porch'}, 
  {value:'ENCLOSED_PORCH', label:'Enclosed Porch'}, 
  {value:'WRAP_AROUND_PORCH', label:'Wrap Around Porch'}, 
  {value:'STOOP', label:'Stoop'}, 
  {value:'FIREPIT', label:'Firepit'}, 
  {value:'OUTDOOR_FIREPLACE', label:'Outdoor Fireplace'}, 
  {value:'OTHER', label:'Other'}, 
  {value:'NONE', label:'None'}, 
  {value:'CARPORT', label:'Carport'}, 
  {value:'ABOVE_GROUND_POOL', label:'Above Ground Pool'}, 
];

const poolConcernEnum= [
  {value:'NONE', label:'None'}, 
  {value:'EMPTY_AND_UNCOVERED', label:'Empty and Uncovered'}, 
  {value:'DAMAGED', label:'Damaged'}, 
  {value:'MISSING_EQUIPMENT', label:'Missing Equipment'}, 
  {value:'DAMAGED_POOL_ENCLOSURE', label:'Damaged Pool Enclosure'}, 
  {value:'UNSANITARY_WATER', label:'Unsanitary Water'}
];

const waterFrontList = [
  'OCEAN_FRONT_BEACH','OCEAN_FRONT_NO_BEACH','INLAND_SALTWATER_FRONT_BEACH','INLAND_SALTWATER_FRONT_NO_BEACH','LAKE_FRONT_BEACH','LAKE_FRONT_NO_BEACH','SEASONAL_LAKE_FRONT','RIVER_CANAL_FRONT'
]
const waterfrontImprovementEnum = [
  {value:'SEAWALL', label:'Seawall'}, 
  {value:'FLOATING_DOCK', label:'Floating Dock'}, 
  {value:'BOAT_LIFT', label:'Boat Lift'}, 
  {value:'DOCK', label:'Dock'}, 
  {value:'PIER', label:'Pier'}, 
  {value:'BOAT_HOUSE', label:'Boat House'}, 
  {value:'BOAT_RAMP', label:'Boat Ramp'}, 
  {value:'NONE', label:'None'}, 
];


const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const PropertyConditions  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio=(size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop=(acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                console.log(field);
                switch(field){
                  case 'imageCondition':
                    let adverseSiteConditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
                    let target1 = adverseSiteConditions[index][field]?adverseSiteConditions[index][field]:[];
      
                    target1.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:adverseSiteConditions[index].ID, description:description});
                    adverseSiteConditions[index][field] = target1;
                    newUPD.property.site.siteFeature.adverseSiteConditions = adverseSiteConditions;
                    break;
                  case 'imageWaterfrontImprovement':
                    let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();
                    let target2 = waterfrontSiteImprovements[index][field]?waterfrontSiteImprovements[index][field]:[];
      
                    target2.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:waterfrontSiteImprovements[index].ID, description:description});
                    waterfrontSiteImprovements[index][field] = target2;
                    newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
                    console.log(waterfrontSiteImprovements)
                    break;
                  case 'imagePropertyImprovement':
                    let propertyImprovements = newUPD.property.site.siteFeature.propertyImprovements.slice();
                    let target3 = propertyImprovements[index][field]?propertyImprovements[index][field]:[];
      
                    target3.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:propertyImprovements[index].ID, description:description});
                    propertyImprovements[index][field] = target3;
                    newUPD.property.site.siteFeature.propertyImprovements = propertyImprovements;
                    console.log(propertyImprovements)
                    break;
                  case 'imageNonResidentialUse':
                    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
                    let target4 = nonResidentialUses[index][field]?nonResidentialUses[index][field]:[];
      
                    target4.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:nonResidentialUses[index].ID, description:description});
                    nonResidentialUses[index][field] = target4;
                    newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
                    console.log(nonResidentialUses)
                    break;
                  default:
                    
                    break;
                }
                
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2=(acceptedFiles, rejectedFiles, index, index2, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
              
                let ingroundPoolConcerns = newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns.slice();
                let target = ingroundPoolConcerns[index2][field]?ingroundPoolConcerns[index2][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:ingroundPoolConcerns[index2].ID, description:description});
                ingroundPoolConcerns[index2][field] = target;
                newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;
                
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateAdverseSiteConditionDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let adverseSiteConditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
    let target = adverseSiteConditions[index]?adverseSiteConditions[index]:[];
    target[field] = value;
    newUPD.property.site.siteFeature.adverseSiteConditions = adverseSiteConditions;

    props.update(newUPD);
  }

  const updatePropertyImprovementDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let propertyImprovements = newUPD.property.site.siteFeature.propertyImprovements.slice();
    let target = propertyImprovements[index]?propertyImprovements[index]:[];
    target[field] = value;
    newUPD.property.site.siteFeature.propertyImprovements = propertyImprovements;

    props.update(newUPD);
  }

  const updateWaterFrontSiteImprovementDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();
    let target = waterfrontSiteImprovements[index]?waterfrontSiteImprovements[index]:[];
    target[field] = value;
    newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;

    props.update(newUPD);
  }

  const updateNonResidentialUseDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
    let target = nonResidentialUses[index]?nonResidentialUses[index]:[];
    target[field] = value;
    newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;

    props.update(newUPD);
  }

  const updateIngroundPoolConcernDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let ingroundPoolConcerns = newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns.slice();
    let target = ingroundPoolConcerns[index]?ingroundPoolConcerns[index]:[];
    target[field] = value;
    newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;

    props.update(newUPD);
  }

  const updateFileDescription=(index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    switch(field){
      case 'imageCondition':
        let adverseSiteConditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
        let target1 = adverseSiteConditions[index][field]?adverseSiteConditions[index][field]:[];

        if(target1 && target1[index2])
          target1[index2].description = description;

        newUPD.property.site.siteFeature.adverseSiteConditions = adverseSiteConditions;
        break;
      case 'imageWaterfrontImprovement':
        let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();
        let target2 = waterfrontSiteImprovements[index][field]?waterfrontSiteImprovements[index][field]:[];

        if(target2 && target2[index2])
          target2[index2].description = description;

        newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
        console.log(waterfrontSiteImprovements)
        break;
      case 'imagePropertyImprovement':
        let propertyImprovements = newUPD.property.site.siteFeature.propertyImprovements.slice();
        let target3 = propertyImprovements[index][field]?propertyImprovements[index][field]:[];

        if(target3 && target3[index2])
        target3[index2].description = description;

        newUPD.property.site.siteFeature.propertyImprovements = propertyImprovements;
        console.log(propertyImprovements)
        break;
      case 'imageNonResidentialUse':
        let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
        let target4 = nonResidentialUses[index][field]?nonResidentialUses[index][field]:[];

        if(target4 && target4[index2])
        target4[index2].description = description;

        newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
        console.log(nonResidentialUses)
        break;
      default:
        
        break;
    }
    
    props.update(newUPD);
  }

  const updateFileDescription2=(index, index2, index3, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let ingroundPoolConcerns = newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns.slice();
    let target = ingroundPoolConcerns[index2][field]?ingroundPoolConcerns[index2][field]:[];
    if(target &&  target[index3]){
      target[index3].description = description;
    }

    newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;
    props.update(newUPD);
  }

  const removeFile2=(field, index, index2, index3)=>{
    let newUPD = Object.assign({}, props.upd);
    let ingroundPoolConcerns = newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns.slice();
    let target = ingroundPoolConcerns[index2][field].slice();

    let targetToDelete = target[index3];
    
    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index3, 1);
        ingroundPoolConcerns[index2][field] = target;
        newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index3, 1);
      ingroundPoolConcerns[index2][field] = target;
      newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;
      props.update(newUPD);
    }
  }

  const removeFile=(field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);

    switch(field){
      case 'imageCondition':
        let adverseSiteConditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
        let target1 = adverseSiteConditions[index][field].slice();

        let targetToDelete1 = target1[index2];

        if(targetToDelete1.ID && targetToDelete1.ID!==-1){
          let successCallBack = ()=>{
            target1.splice(index2, 1);
            adverseSiteConditions[index][field] = target1;
            newUPD.property.site.siteFeature.adverseSiteConditions = adverseSiteConditions;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete1.ID, props, successCallBack);
        }
        else{
          target1.splice(index2, 1);
          adverseSiteConditions[index][field] = target1;
          newUPD.property.site.siteFeature.adverseSiteConditions = adverseSiteConditions;
          props.update(newUPD);
        }
        break;
      case 'imagePropertyImprovement':
        let propertyImprovements = newUPD.property.site.siteFeature.propertyImprovements.slice();
        let target2 = propertyImprovements[index][field].slice();

        let targetToDelete2 = target2[index2];

        if(targetToDelete2.ID && targetToDelete2.ID!==-1){
          let successCallBack = ()=>{
            target2.splice(index2, 1);
            propertyImprovements[index][field] = target2;
            newUPD.property.site.siteFeature.propertyImprovements = propertyImprovements;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete2.ID, props, successCallBack);
        }
        else{
          target2.splice(index2, 1);
          propertyImprovements[index][field] = target2;
          newUPD.property.site.siteFeature.propertyImprovements = propertyImprovements;
          props.update(newUPD);
        }
        break;
      case 'imageWaterfrontImprovement':
        let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();
        let target3 = waterfrontSiteImprovements[index][field].slice();

        let targetToDelete3 = target3[index2];

        if(targetToDelete3.ID && targetToDelete3.ID!==-1){
          let successCallBack = ()=>{
            target3.splice(index2, 1);
            waterfrontSiteImprovements[index][field] = target3;
            newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete3.ID, props, successCallBack);
        }
        else{
          target3.splice(index2, 1);
          waterfrontSiteImprovements[index][field] = target3;
          newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
          props.update(newUPD);
        }
        break;
      case 'imageNonResidentialUse':
        let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
        let target4 = nonResidentialUses[index][field].slice();

        let targetToDelete4 = target4[index2];

        if(targetToDelete4.ID && targetToDelete4.ID!==-1){
          let successCallBack = ()=>{
            target4.splice(index2, 1);
            nonResidentialUses[index][field] = target4;
            newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
            props.update(newUPD);
          };
          successCallBack = successCallBack.bind(this);
          deletePhoto(targetToDelete4.ID, props, successCallBack);
        }
        else{
          target4.splice(index2, 1);
          nonResidentialUses[index][field] = target4;
          newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
          props.update(newUPD);
        }
        break;
      default:
                    
        break;
    }
    
  }

  const getConditionLabel=(condition)=>{
    for(let i=0;i<conditionEnum.length;i++){
      if(conditionEnum[i].value===condition)
        return conditionEnum[i].label;
    }

    return condition;
  }

  const getNonResidentialUseLabel=(nonResidentialUse)=>{
    for(let i=0;i<nonResidentialUseEnum.length;i++){
      if(nonResidentialUseEnum[i].value===nonResidentialUse)
        return nonResidentialUseEnum[i].label;
    }

    return nonResidentialUse;
  }

  const getWaterfrontImprovementLabel=(improvement)=>{
    for(let i=0;i<waterfrontImprovementEnum.length;i++){
      if(waterfrontImprovementEnum[i].value===improvement)
        return waterfrontImprovementEnum[i].label;
    }

    return improvement;
  }

  const getImprovementLabel=(improvement)=>{
    for(let i=0;i<improvementEnum.length;i++){
      if(improvementEnum[i].value===improvement)
        return improvementEnum[i].label;
    }

    return improvement;
  }

  const getPoolConcernLabel=(poolConcern)=>{
    console.log(poolConcern);
    for(let i=0;i<poolConcernEnum.length;i++){
      if(poolConcernEnum[i].value===poolConcern)
        return poolConcernEnum[i].label;
    }
    
    return poolConcern;
  }

  const updateCondition=(condition)=>{
    let newUPD = Object.assign({}, props.upd);
    let conditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();

    if(condition==='NONE_OBSERVED'){
      conditions = [{adverseType:condition, adverseSiteConditionDescription:'', imageCondition:[]}];
    }
    else{
      for(let i=0;i<conditions.length;i++){
        if(conditions[i].adverseType==='NONE_OBSERVED'){
          conditions = [];
          break;
        }
      }
      conditions.push({adverseType:condition, adverseSiteConditionDescription:'', imageCondition:[]});
    }
    
    newUPD.property.site.siteFeature.adverseSiteConditions = conditions;
    props.update(newUPD);
  }

  const updateWaterfrontImprovement=(waterfrontImprovement)=>{
    let newUPD = Object.assign({}, props.upd);
    let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();

    if(waterfrontImprovement==='NONE'){
      waterfrontSiteImprovements = [{waterfrontImprovementType:waterfrontImprovement}];
    }
    else{
      for(let i=0;i<waterfrontSiteImprovements.length;i++){
        if(waterfrontSiteImprovements[i].waterfrontImprovementType==='NONE'){
          waterfrontSiteImprovements = [];
          break;
        }
      }
      waterfrontSiteImprovements.push({waterfrontImprovementType:waterfrontImprovement, imageWaterfrontImprovement:[]});
    }
    
    newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
    props.update(newUPD);
  }

  const updateNonResidentialUse=(nonResidentialUse)=>{
    let newUPD = Object.assign({}, props.upd);
    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();

    if(nonResidentialUse==='NONE_OBSERVED'){
      nonResidentialUses = [{nonResidentialUseType:nonResidentialUse, nonResidentialUseDescription:''}];
    }
    else{
      for(let i=0;i<nonResidentialUses.length;i++){
        if(nonResidentialUses[i].nonResidentialUseType==='NONE_OBSERVED'){
          nonResidentialUses = [];
          break;
        }
      }

      nonResidentialUses.push({nonResidentialUseType:nonResidentialUse, nonResidentialUseDescription:'', imageNonResidentialUse:[]});
    }
    
    newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
    props.update(newUPD);
  }

  const updateImprovement=(improvement)=>{
    let newUPD = Object.assign({}, props.upd);
    let improvements = newUPD.property.site.siteFeature.propertyImprovements.slice();
 
    if(improvement==='NONE'){
      improvements = [{propertyImprovementType:improvement, propertyImprovementDescription:''}];
    }
    else{
      for(let i=0;i<improvements.length;i++){
        if(improvements[i].propertyImprovementType==='NONE'){
          improvements = [];
          break;
        }
      }

      if(improvement==='INGROUND_POOL')
        improvements.push({propertyImprovementType:improvement, propertyImprovementDescription:'', ingroundPoolConcerns:[], imagePropertyImprovement:[]});
      else
        improvements.push({propertyImprovementType:improvement, propertyImprovementDescription:'', imagePropertyImprovement:[]});
    }
    console.log(improvements)
    newUPD.property.site.siteFeature.propertyImprovements = improvements;
    props.update(newUPD);
  }

  const updatePoolConcern=(index, poolConcern)=>{
    let newUPD = Object.assign({}, props.upd);
    let ingroundPoolConcerns = newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns.slice();
 
    if(poolConcern==='NONE'){
      ingroundPoolConcerns = [{poolConcernType:poolConcern, poolConcernDescription:''}];
    }
    else{
      for(let i=0;i<ingroundPoolConcerns.length;i++){
        if(ingroundPoolConcerns[i].poolConcernType==='NONE'){
          ingroundPoolConcerns = [];
          break;
        }
      }

      ingroundPoolConcerns.push({poolConcernType:poolConcern, poolConcernDescription:'',imagePoolConcern:[]});
    }
    
    newUPD.property.site.siteFeature.propertyImprovements[index].ingroundPoolConcerns = ingroundPoolConcerns;
    props.update(newUPD);
  }

  const updateConditionDescription=(index, condition)=>{
    let newUPD = Object.assign({}, props.upd);
    let conditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
    conditions[index].adverseSiteConditionDescription = condition;

    newUPD.property.site.siteFeature.adverseSiteConditions = conditions;
    props.update(newUPD);
  }

  const updateNonResidentialUseDescription=(index, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
    nonResidentialUses[index].nonResidentialUseDescription = description;

    newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
    props.update(newUPD);
  }

  const updateImprovementDetail=(index, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let improvements = newUPD.property.site.siteFeature.propertyImprovements.slice();
    improvements[index].propertyImprovementDescription = value;
  
    newUPD.property.site.siteFeature.propertyImprovements = improvements;
    props.update(newUPD);
  }

  const updatePoolConcernDetail=(index, index2, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let improvements = newUPD.property.site.siteFeature.propertyImprovements.slice();
    let ingroundPoolConcerns = improvements[index].ingroundPoolConcerns.slice();
    ingroundPoolConcerns[index2].poolConcernDescription = value;
    improvements[index].ingroundPoolConcerns = ingroundPoolConcerns;
  
    newUPD.property.site.siteFeature.propertyImprovements = improvements;
    props.update(newUPD);
  }

  const removeCondition=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let conditions = newUPD.property.site.siteFeature.adverseSiteConditions.slice();
    conditions.splice(index, 1);

    newUPD.property.site.siteFeature.adverseSiteConditions = conditions;
    props.update(newUPD);
  }

  const removeWaterfrontImprovement=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let waterfrontSiteImprovements = newUPD.property.site.siteFeature.waterfrontSiteImprovements.slice();
    waterfrontSiteImprovements.splice(index, 1);

    newUPD.property.site.siteFeature.waterfrontSiteImprovements = waterfrontSiteImprovements;
    props.update(newUPD);
  }

  const removeIngroundPoolConcern=(index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let improvements = newUPD.property.site.siteFeature.propertyImprovements.slice();
    let ingroundPoolConcerns = improvements[index].ingroundPoolConcerns.slice();
    ingroundPoolConcerns.splice(index2,1);
    improvements[index].ingroundPoolConcerns = ingroundPoolConcerns;
  
    newUPD.property.site.siteFeature.propertyImprovements = improvements;
    props.update(newUPD);
  }

  const removeNonResidentialUse=(index,)=>{
    let newUPD = Object.assign({}, props.upd);
    let nonResidentialUses = newUPD.property.site.siteFeature.nonResidentialUses.slice();
    nonResidentialUses.splice(index, 1);

    newUPD.property.site.siteFeature.nonResidentialUses = nonResidentialUses;
    props.update(newUPD);
  }

  const removeImprovement=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let improvements = newUPD.property.site.siteFeature.propertyImprovements.slice();
    improvements.splice(index, 1);

    newUPD.property.site.siteFeature.propertyImprovements = improvements;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }
 
  //render
  let hasWaterfront = false;

  for(let i=0;i<props.upd.property.site.siteFeature.location.locations.length;i++){
    if(waterFrontList.indexOf(props.upd.property.site.siteFeature.location.locations[i].locationDescriptionType)!==-1){
      hasWaterfront = true;
      break;
    }
  }

  return <div>
    <Card>
      <CardHeader className="header-color">Site Condition</CardHeader>
      <CardBody>
        <label>{!props.disabled?<font color="red">*</font>:null}Indicate any adverse site conditions observed on the subject property. {generateTooltip('adverseType', 'User to indicate adverse factors or concerns observed on the subject site. This does not include problems on adjacent or neighboring properties.')}</label>
        <MySelect
          type="select"
          required={!props.disabled}
          disabled={props.disabled}
          style={props.disabled?disabledStyling:{}}
          value={props.upd.property.site.siteFeature.adverseSiteConditions && props.upd.property.site.siteFeature.adverseSiteConditions.length>0?" ":""}
          onChange={(v)=>updateCondition(v)}
          options={conditionEnum}
        />
        {
          props.upd.property.site.siteFeature.adverseSiteConditions.map(
            (condition, index)=>{
              if(condition.adverseType==='NONE_OBSERVED'){
                return <div key={index} style={{marginTop:'15px'}}>
                  <b>None Observed</b>
                </div>
              }
              else{
                return <Card key={index} style={{marginTop:'15px'}}>
                  <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeCondition(index)}/> {getConditionLabel(condition.adverseType)}</CardHeader>
                  <CardBody>
                    <label>{!props.disabled?<font color="red">*</font>:null}Description {generateTooltip('adverseType'+index, 'User to provide a concise description of the adverse site factor(s) observed.')}</label>
                    <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={condition.adverseSiteConditionDescription} onChange={(e)=>updateConditionDescription(index,e.target.value)}/>

                    <label><font color="red">*</font>Image(s) of adverse conditions  {generateTooltip('imageCondition'+index, 'Image(s) evidencing adverse factor identified (e.g. sinkhole, failing structure, etc.) ')}</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={condition.imageCondition&&condition.imageCondition.length>0?" ":""}
                      required={!props.disabled}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageCondition', 'ADVERSE_SITE_CONDITIONS', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !condition.imageCondition?null:condition.imageCondition.map(
                          (photo, index2)=>{
                            return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageCondition',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageCondition', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </CardBody>
                </Card>
              }
            }
          )
        }
        <br/>
        {props.upd.property.propertyType==='SF'?<div>
          <label>{!props.disabled?<font color="red">*</font>:null}Are there any features, amenities, or structures in place that add utility or improve the appeal for the subject's site? Select the option(s) that best describe observed features.  These features include elements attached and detached from the structures on the property that contribute to the appeal of the site. {generateTooltip('propertyImprovementType', 'User to note amenities and property features that are not attached to another structure that improve the appeal of the property. The user should add one element for each feature observed.')}</label>
          <MySelect
            type="select"
            required={!props.disabled}
            disabled={props.disabled}
            style={props.disabled?disabledStyling:{}}
            value={props.upd.property.site.siteFeature.propertyImprovements && props.upd.property.site.siteFeature.propertyImprovements.length>0?" ":""}
            onChange={(v)=>updateImprovement(v)}
            options={improvementEnum}
          />
          <div className="red-color" style={{fontSize:'13px'}}>
            <i className="fa fa-check green-color"/> Include features like porch, fence, deck, patio <br/>
            <i className="fa fa-check green-color"/> Add all visible improvements from photos<br/>
            <i className="fa fa-times red-color"/> Do NOT include buildings (barn, ADU, shed) here <br/>
          </div>
          {
            props.upd.property.site.siteFeature.propertyImprovements.map(
              (improvement, index)=>{
                console.log(improvement)
                let poolConcernType;
                
                if(improvement.propertyImprovementType==='INGROUND_POOL'){
                  poolConcernType = <div>
                    <label>{!props.disabled?<font color="red">*</font>:null}Are there any obvious concerns (damage or needed repairs) with the inground pool? Select the options that best describe each observed concern. {generateTooltip('poolConcernType'+index, 'If the user identifies an in-ground swimming pool, this is a required element for the user to note damage or other concerns. The user should add a new observation for each concern observed. If there are no concerns, the user should select the \'NONE\' option.')}</label>
                    <MySelect
                      type="select"
                      required={!props.disabled}
                      disabled={props.disabled}
                      style={props.disabled?disabledStyling:{}}
                      value={improvement.ingroundPoolConcerns && improvement.ingroundPoolConcerns.length>0?" ":""}
                      onChange={(v)=>updatePoolConcern(index, v)}
                      options={poolConcernEnum}
                    />
                    {
                      improvement.ingroundPoolConcerns.map(
                        (poolConcern, index2)=>{
                          if(poolConcern.poolConcernType!=='NONE'){
                            return <Card key={index2} style={{marginTop:'5px'}}>
                              <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeIngroundPoolConcern(index, index2)}/> {getPoolConcernLabel(poolConcern.poolConcernType)}</CardHeader>
                              <CardBody>
                                <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each pool concern observed. {generateTooltip('poolConcernDescription'+index, 'If the user identifies any in-ground swimming pool concerns, the user must provide a concise free form text description for each type of damage or concern selected.')}</label>
                                <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={poolConcern.poolConcernDescription} onChange={(e)=>updatePoolConcernDetail(index, index2, e.target.value)}/>

                                <br/>
                                <label><font color="red">*</font>Image(s) of swimming pool deficiencies {generateTooltip('imagePoolConcern', 'Image(s) of each swimming pool deficiency identified. Ensure enough images are captured to show the location and extent of the damage. Note: This image should only be populated in cases where swimming pool deficiencies have been identified in the data.')}</label>
                                <br/>
                                <input
                                  tabIndex={-1}
                                  autoComplete="off"
                                  style={{ opacity: 0, height: 0, width:0 }}
                                  value={poolConcern.imagePoolConcern&&poolConcern.imagePoolConcern.length>0?" ":""}
                                  required={!props.disabled}
                                />
                                <div>
                                  <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, index2, 'imagePoolConcern', 'INGROUND_POOL_CONCERNS', 0)}} className="my-dropzone">
                                  {
                                    ({getRootProps, getInputProps}) => (
                                      <div
                                        {...getRootProps({
                                          className: 'my-dropzone',
                                        })}
                                      >
                                        <input {...getInputProps()} />
                                        <center>Choose files to upload</center>
                                      </div>
                                    )
                                  }
                                  </Dropzone>
                                  {
                                    !poolConcern.imagePoolConcern?null:poolConcern.imagePoolConcern.map(
                                      (photo, index3)=>{
                                        return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                          <div>
                                            <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imagePoolConcern',index, index2, index3)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                          </div>
                                          <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                          {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, index3, 'imagePoolConcern', e.target.value)}/>
                                          <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                                        </div>
                                      }
                                    )
                                  }
                                </div>
                              </CardBody>
                            </Card>;
                          }
                          else
                            return <div key={index} style={{marginTop:'15px'}}>
                              <b>None Observed</b>
                            </div>
                        }
                      )
                    }
                  </div>;
                }

                if(improvement.propertyImprovementType==='NONE'){
                  return <div key={index} style={{marginTop:'15px'}}>
                    <b>None</b>
                  </div>
                }
                else{
                  return <Card key={index} style={{marginTop:'15px'}}>
                    <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeImprovement(index)}/> {getImprovementLabel(improvement.propertyImprovementType)}</CardHeader>
                    <CardBody>
                      <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of site improvement observed. {generateTooltip('propertyImprovementDescription'+index, 'User to provide a concise description of the site improvement such as size, features, and condition. Example: Small 10’ x 10’ gazebo with composite decking  with no issues noted.')}</label>
                      <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={improvement.propertyImprovementDescription} onChange={(e)=>updateImprovementDetail(index,e.target.value)}/>
                      <br/>
                      <label><font color="red">*</font>Image(s) of property improvement  {generateTooltip('imagePropertyImprovement', 'Image(s) of each site improvement identified (e.g. swimming pool, hot tub, outdoor kitchen, etc.).  For items such as a graywater systems that not visible, provide images of control systems or the general area where the system is located. Note: This image should only be populated in cases where site improvements have been identified in the data.')}</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={improvement.imagePropertyImprovement&&improvement.imagePropertyImprovement.length>0?" ":""}
                        required={!props.disabled}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imagePropertyImprovement', 'PROPERTY_IMPROVEMENTS', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !improvement.imagePropertyImprovement?null:improvement.imagePropertyImprovement.map(
                            (photo, index2)=>{
                              return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imagePropertyImprovement',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imagePropertyImprovement', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                      <br/>
                      {poolConcernType}
                    </CardBody>
                  </Card>
                }
              }
            )
          }
        </div>:null}

        {props.upd.property.propertyType==='SF'?<div>
          <label>{!props.disabled?<font color="red">*</font>:null}What non-residential uses were observed? Select the best options to identify observed non-residential uses. {generateTooltip('nonResidentialUse', 'User to note observed uses, fixtures, and/or finishes that support non-residential uses. If there are no observed non-residential uses, the user should select "None Observed".')}</label>
          <MySelect
            type="select"
            required={!props.disabled}
            disabled={props.disabled}
            style={props.disabled?disabledStyling:{}}
            value={props.upd.property.site.siteFeature.nonResidentialUses && props.upd.property.site.siteFeature.nonResidentialUses.length>0?" ":""}
            onChange={(v)=>updateNonResidentialUse(v)}
            options={nonResidentialUseEnum}
          />
          {
            props.upd.property.site.siteFeature.nonResidentialUses.map(
              (nonResidentialUse, index)=>{
                if(nonResidentialUse.nonResidentialUseType==='NONE_OBSERVED'){
                  return <div key={index} style={{marginTop:'15px'}}>
                    <b>None Observed</b>
                  </div>
                }
                else{
                  return <Card key={index} style={{marginTop:'15px'}}>
                    <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeNonResidentialUse(index)}/> {getNonResidentialUseLabel(nonResidentialUse.nonResidentialUseType)}</CardHeader>
                    <CardBody>
                      <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of any non-residential use(s) observed.</label>
                      <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={nonResidentialUse.nonResidentialUseDescription} onChange={(e)=>updateNonResidentialUseDescription(index,e.target.value)}/>
                      <br/>
                      <label><font color="red">*</font>Image(s) of non-residential use  {generateTooltip('imageNonResidentialUse', 'Image(s) of each non-residential identified. Provide images of the things observed that lead to the conclusion that a non-residential use exists. Note: This image should only be populated in cases where a non-residential use has been identified in the data.')}</label>
                      <br/>
                      <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0, width:0 }}
                        value={nonResidentialUse.imageNonResidentialUse&&nonResidentialUse.imageNonResidentialUse.length>0?" ":""}
                        required={!props.disabled}
                      />
                      <div>
                        <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageNonResidentialUse', 'NONRESIDENTIAL_USE', 0)}} className="my-dropzone">
                        {
                          ({getRootProps, getInputProps}) => (
                            <div
                              {...getRootProps({
                                className: 'my-dropzone',
                              })}
                            >
                              <input {...getInputProps()} />
                              <center>Choose files to upload</center>
                            </div>
                          )
                        }
                        </Dropzone>
                        {
                          !nonResidentialUse.imageNonResidentialUse?null:nonResidentialUse.imageNonResidentialUse.map(
                            (photo, index2)=>{
                              return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                                <div>
                                  <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageNonResidentialUse',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                                </div>
                                <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                                {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageNonResidentialUse', e.target.value)}/>
                                <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                              </div>
                            }
                          )
                        }
                      </div>
                    </CardBody>
                  </Card>
                }
              }
            )
          }
          <br/>
        </div>:null}
        <br/>
        {props.upd.property.propertyType==='SF' && hasWaterfront?<div>
          <label>{!props.disabled?<font color="red">*</font>:null}Are there any features, amenities, or structures in place that add utility or improve the appeal to the waterfront? Select the option(s) that best describe observed features.</label>
          <MySelect
            type="select"
            required={!props.disabled && props.upd.property.propertyType==='SF' && hasWaterfront}
            disabled={props.disabled}
            style={props.disabled?disabledStyling:{}}
            value={props.upd.property.site.siteFeature.waterfrontSiteImprovements && props.upd.property.site.siteFeature.waterfrontSiteImprovements.length>0?" ":""}
            onChange={(v)=>updateWaterfrontImprovement(v)}
            options={waterfrontImprovementEnum}
          />
          {
            props.upd.property.site.siteFeature.waterfrontSiteImprovements.map(
              (waterfrontImprovement, index)=>{
                if(waterfrontImprovement.waterfrontImprovementType==='NONE'){
                  return <div key={index} style={{marginTop:'15px'}}>
                    <b>None</b>
                  </div>
                }
                else{
                  return <Card key={index}>
                  <CardHeader>
                    <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeWaterfrontImprovement(index)}/> {getWaterfrontImprovementLabel(waterfrontImprovement.waterfrontImprovementType)}
                  </CardHeader>
                  <CardBody>
                    <br/>
                    <label><font color="red">*</font>Image(s) of waterfront improvements {generateTooltip('imageWaterfrontImprovement', 'Image(s) of structures and features on the waterfront (e.g. docks, bulkheads, etc.). Note: This image should only be populated in cases where waterfront improvements have been identified.')}</label>
                    <br/>
                    <input
                      tabIndex={-1}
                      autoComplete="off"
                      style={{ opacity: 0, height: 0, width:0 }}
                      value={waterfrontImprovement.imageWaterfrontImprovement&&waterfrontImprovement.imageWaterfrontImprovement.length>0?" ":""}
                      required={!props.disabled}
                    />
                    <div>
                      <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageWaterfrontImprovement', 'WATERFRONT_SITE_IMPROVEMENTS', 0)}} className="my-dropzone">
                      {
                        ({getRootProps, getInputProps}) => (
                          <div
                            {...getRootProps({
                              className: 'my-dropzone',
                            })}
                          >
                            <input {...getInputProps()} />
                            <center>Choose files to upload</center>
                          </div>
                        )
                      }
                      </Dropzone>
                      {
                        !waterfrontImprovement.imageWaterfrontImprovement?null:waterfrontImprovement.imageWaterfrontImprovement.map(
                          (photo, index2)=>{
                            return <div key={index} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                              <div>
                                <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageWaterfrontImprovement',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                              </div>
                              <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                              {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageWaterfrontImprovement', e.target.value)}/>
                              <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                            </div>
                          }
                        )
                      }
                    </div>
                  </CardBody>
                  
                </Card>
                }
              }
            )
          }
        </div>:null}
      </CardBody>
    </Card>
  </div>
}


export default PropertyConditions;